import { getStorage } from '@/utils/taroApi';
import action from '@/utils/action';
import * as url from '@/src/constant';
import { jump } from '@/utils/jump';
import Cookies from 'js-cookie';
import { version } from '../../package.json';

// 账号注销检查拦截
export const logOffCheck = async (that) => {
  const { common, user } = that.props.store;
  await common.getAksInfo();
  await user.getSettleStatus();
  const { accountStatus } = user.settleStatus;
  // 账号已注销， 跳转提示页
  if (accountStatus === 'INVALID') {
    jump({
      url: '/pages/tip-account-invalid/index'
    });
  }
}

// 判断代码版本是否最新
export const isLatestVersion = () => {
  const nowVersion = Cookies.get('version');
  // 如果代码版本不一致
  if (!nowVersion || nowVersion !== version) {
    // 更新版本信息
    Cookies.set('version', version, { expires: 365 });
    return false;
  }
  return true;
}

// 是否在H5环境
export const isH5 = process.env.TARO_ENV === 'h5';
// 是否在微信小程序环境
export const isWeApp = process.env.TARO_ENV === 'weapp';
// 当前域名
const locationUrl = isH5 ? window.location.origin : url.LOCATION_BASEURL;

// 获取实名地址(create: 新注册实名；edit：修改实名)
export const getRealnameUrl = (path, type = 'create') => {
  if (type === 'edit') {
    return url.REALNAME_CHANGE_BASEURL;
  }
  return `${url.REALNAME_BASEURL}${encodeURIComponent(locationUrl + path)}`;
}

// 获取绑卡地址
export const getNewCardUrl = (path) => `${url.NEWCARD_BASEURL}${encodeURIComponent(locationUrl + path)}`;

// 更改页面标题
export const setTitle = (opts) => {
  document.title = opts.title;
  console.log(document.title)
  const i = document.createElement('iframe');
  i.style.display = 'none';
  i.onload = () => {
    setTimeout(() => {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
}

// 图片大小
export const getBase64ImgSize = (data) => {
  let urlBase64 = data.replace('data:image/png;base64,', '');
  urlBase64 = urlBase64.replace('data:image/jpg;base64,', '');
  const equalIndex = urlBase64.indexOf('=');
  if (equalIndex > 0) {
    urlBase64 = urlBase64.substring(0, equalIndex)
  }
  const rLength = urlBase64.length;
  // const limit = 100000;
  // console.log('size: ', fileLength)
  return parseInt(rLength - (rLength / 8) * 2);
}

// 图片信息
export const getImageInfo = (imgUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img)
    }
    img.onerror = () => {
      reject(new Error('图片加载失败'))
    }
    img.src = imgUrl;
    img.setAttribute("crossOrigin", 'Anonymous');	//url为外域时需要
  })
}

// 将(分)转化为(元)，并保留两位小数，逗号分割金额
export const keepTwoDecimalFull = (number) => {
  let num = number/100; //元
  let result = parseFloat(num);
  result = Math.round(num * 100) / 100;
  let s_x = String(result); //将数字转换为字符串
  let pos_decimal = s_x.indexOf('.'); //小数点的索引值
  // 当整数时，pos_decimal=-1 自动补0
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += '.';
  }
  // 当数字的长度< 小数点索引+2时，补0
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0';
  }
  return s_x.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

// 处理字符串
export const dealImgString = (str) => {
  let index = str.lastIndexOf("\,");
  str = str.substring(index + 1, str.length);
  return str.replace(/[\r\n]/g, '');
};

// 判断身份证审核状态
const judgeStatus = (status) => {
  switch (status) {
    case 'PROC':
      return true;
    case 'SUCC':
      return false;
    case 'FAIL':
      return false;
    default:
      return true;
  }
};

// 是否调用身份证状态查询接口
export const isQueryUserInfo = () => {
  const status = getStorage('cert_audit_status');
  return judgeStatus(status);
};

// 实名脱敏
export const hideUserName = (str = '') => {
  if (!str) return ''

  const string = String(str);
  const number = string.length;
  const retain = number > 2 ? 2 : 1;
  let name = '';

  for (let i=0; i<number-retain; i++) {
    name += '*';
  }
  name += string.slice(-1*retain)
  return name;
}

// 手机号脱敏
export const hideUserNo = (str = '') => {
  if (!str) return ''

  let s = String(str);
  return s.slice(0, 3) + '****' + s.slice(-4);
}

/**
   * 生成唯一随机数
   * @param {Number} len 生成的文件名长度
   * @param {Number} radix 指定基数
   */
function getuuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i = 0
  radix = radix || chars.length

  if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
      var r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'

      for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
              r = 0 | Math.random() * 16
              uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
      }
  }

  return uuid.join('')
}
/**
  * 生成唯一字符串 时间戳 + 随机数
  * @param {Number} len 生成的文件名长度
  * @param {Number} radix 指定基数
  */
export function getTimeId(len, radix) {
  if (len) {
    const time = new Date().getTime()
    const uuid = getuuid(len, radix)
    return `${time}${uuid}`
  } else {
    console.log('请输入长度')
  }
}
